import React from 'react';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../../components/Bootstrap/Portlet';
import {
  Tab,
  Tabs,
} from 'react-bootstrap';
import Reconciliation from './Reconciliation';
import ReportTable from './ReportTable';

const Reports = observer((props) => {
  const { t } = props;

  return (
    <Portlet>
      <PortletTitle>
        <PortletCaption>{t('Reports')}</PortletCaption>
      </PortletTitle>
      <PortletBody>
        <Tabs defaultActiveKey={1} id="materials">
          <Tab eventKey={1} title={t('Inventory Usage')}>
            <ReportTable/>
          </Tab>
          <Tab eventKey={2} title={t('Reconciliation')}>
            <Reconciliation/>
          </Tab>
        </Tabs>
      </PortletBody>
    </Portlet>
  );
});

export default withTranslation()(Reports);
